import http from "../http-common";

const verifyCoupon = data => {
    return http.post("/coupons/validate", data)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            let e = error;
            if(e.response.data.message) {
                console.log(e.response.data.message);
                return {error: true};
            }
            return error;
        });
};

const CouponService = {
    verifyCoupon,
};

export default CouponService;
